import React from 'react'
import Link from 'gatsby-link'
import './Header.css'

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll',
    this.handleScroll)
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset
  
    if (scrollTop > 50) {
      this.setState({ hasScrolled: true })
    } else {
      this.setState({ hasScrolled: false })
    }
  }

  render() {
    return(
      <div className={this.state.hasScrolled ? 'Header HeaderScrolled' : 'Header'}>
      <div className="HeaderGroup">
      <Link to="/"><img src={require('../images/static.png')} width="80" /></Link>
        <Link to="/">Home</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/about">About Me</Link>
        <a href="/contact"><button>Contact Me</button></a>
      </div>
    </div>
    )
  }
}

export default Header

// import React from 'react';
// import Link from 'gatsby-link';
// import './Header.css';

// class Header extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       hasScrolled: false
//     };
//   }

//   componentDidMount() {
//     // Only add the scroll listener if not on the register page
//     if (this.props.location.pathname !== './register.js') {
//       window.addEventListener('scroll', this.handleScroll);
//     }
//   }

//   componentWillUnmount() {
//     // Remember to remove the listener when the component unmounts
//     window.removeEventListener('scroll', this.handleScroll);
//   }

//   handleScroll = (event) => {
//     const scrollTop = window.pageYOffset;

//     if (scrollTop > 50) {
//       this.setState({ hasScrolled: true });
//     } else {
//       this.setState({ hasScrolled: false });
//     }
//   };

//   render() {
//     return (
//       <div className={this.state.hasScrolled ? 'Header HeaderScrolled' : 'Header'}>
//         <div className="HeaderGroup">
//           <Link to="/"><img src={require('../images/static.png')} width="80" /></Link>
//           <Link to="/">Home</Link>
//           <Link to="/projects">Projects</Link>
//           <Link to="/about">About Me</Link>
//           <a href="/contact"><button>Contact Me</button></a>
//         </div>
//       </div>
//     );
//   }
// }

// export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js